export const SITE_NAME = "VenturesDirectory";
export const SITE_URL = "https://venturesdirectory.com";
export const SITE_LOCALE = "en_IN";
export const TWITTER_HANDLE = "@venturesdirectory";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.svg`;
export const SUPPORT_EMAIL = "support@venturesdirectory.com";
export const SUPPORT_PHONE = "+919618641100";

export const DEFAULT_DESCRIPTION =
  "Discover real estate ventures across Telangana. Search projects by name or location, explore RERA, HMDA and DTCP details, and research with greater confidence on VenturesDirectory.";

export const ORGANIZATION_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  email: SUPPORT_EMAIL,
  telephone: SUPPORT_PHONE,
  logo: DEFAULT_OG_IMAGE,
  description: DEFAULT_DESCRIPTION,
  address: {
    "@type": "PostalAddress",
    streetAddress: "#302, P & T Colony, Dilsukhnagar",
    addressLocality: "Hyderabad",
    addressRegion: "Telangana",
    postalCode: "500060",
    addressCountry: "IN"
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: SUPPORT_PHONE,
      contactType: "customer support",
      email: SUPPORT_EMAIL,
      areaServed: "IN",
      availableLanguage: ["English", "Telugu", "Hindi"]
    }
  ]
};

export const WEBSITE_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: SITE_URL,
  description: DEFAULT_DESCRIPTION,
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${SITE_URL}/?q={search_term_string}`
    },
    "query-input": "required name=search_term_string"
  }
};

export const PAGE_SEO = {
  home: {
    title: "Real Estate Venture Directory for Telangana",
    description: DEFAULT_DESCRIPTION,
    path: "/",
    jsonLd: [ORGANIZATION_JSON_LD, WEBSITE_JSON_LD]
  },
  about: {
    title: "About Us",
    description:
      "Learn how VenturesDirectory helps buyers, investors, agents and developers discover ventures, check approval references, and research projects across Telangana.",
    path: "/about"
  },
  howItWorks: {
    title: "How It Works",
    description:
      "Search ventures by name or location, explore available RERA and approval details, request more information, and keep project listings updated on VenturesDirectory.",
    path: "/how-it-works"
  },
  contact: {
    title: "Contact Us",
    description:
      "Contact VenturesDirectory for sales, support, WhatsApp assistance, or venture listing help. Reach us in Hyderabad by phone, email, or WhatsApp.",
    path: "/contact",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: `Contact ${SITE_NAME}`,
      url: `${SITE_URL}/contact`,
      description:
        "Contact VenturesDirectory for sales, support, WhatsApp assistance, or venture listing help."
    }
  },
  blog: {
    title: "Real Estate Research & Verification Guides",
    description:
      "Expert guides on RERA verification, HMDA/DTCP approvals, plot due diligence, and AI-powered property search in Telangana.",
    path: "/blog"
  }
};
